"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.splice.js");
var _pathToRegexp = _interopRequireDefault(require("path-to-regexp"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var normalize = function normalize(path) {
  path = path || '';
  if (path[0] === '/') {
    path = path.substring(1);
  }
  return '/' + path;
};
var _default = exports["default"] = function _default(pattern) {
  pattern = normalize(pattern);
  var keys = [];
  var regex = (0, _pathToRegexp["default"])(pattern, keys);
  var paramNames = keys.map(function (key) {
    return key.name;
  });
  return function (pathname) {
    pathname = normalize(pathname);
    var match = regex.exec(pathname);
    if (!match) {
      return false;
    } else {
      var result = {};
      match.splice(1).forEach(function (paramValue, index) {
        result[paramNames[index]] = paramValue;
      });
      return result;
    }
  };
};
//# sourceMappingURL=route-parser.js.map